import { createColumnHelper } from '@tanstack/react-table';

import { DecoratedStack } from '../types';

export const columnHelper = createColumnHelper<DecoratedStack>();
